// src/modules/reports/constants/filters/inventory-shared.filters.ts
import { FilterType } from '@dfl/mui-admin-layout';
import { transformWhitObjectId } from 'modules/common/constants/object-id';
import { WAREHOUSES_LIST_KEY } from 'modules/inventory/warehouse/constants';
import { WarehouseService } from 'modules/inventory/warehouse/services';

export const warehouseFilter = {
  filter: 'warehouse:list',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  key: 'warehouse',
  labelKey: 'name',
  field: 'warehouse',
  fetchFunc: WarehouseService.search,
  fetchOption: { size: 200 },
  queryKey: WAREHOUSES_LIST_KEY,
  transform: (value: any) => transformWhitObjectId(value, 'warehouse'),
};
